export class APIAuth {
    username: string;
    password: string;

    constructor (params: { username: string; password: string}) {
        this.username = params.username
        this.password = params.password
    }
}

export class APIResetPassword {
    email: string;
    pin: number;
    password: string;
    confirmPassword: string;

    constructor (params: {
        email: string;
        pin: number;
        password: string;
        confirmPassword: string;
    }) {
        this.email = params.email
        this.pin = params.pin
        this.password = params.password
        this.confirmPassword = params.confirmPassword
    }
}
